export default "__VITE_ASSET__DnZ4QYc___"